// ZUGFeRD / Factur-X PDF handling: extract the embedded XML attachment via pdf.js (D-023).
// pdf.js is dynamically imported so it stays out of the initial chunk and only loads when a PDF
// is actually dropped. Its worker is version-matched and served from /engines/ (offline-cache
// friendly). pdf.js needs NO Firefox patch (unlike xmllint-wasm) — verified in D-023.

import { pdfWorkerUrl } from './assets';

// Known embedded-invoice attachment names (BRIEF §4), plus a first-XML fallback.
const KNOWN_ATTACHMENTS = ['factur-x.xml', 'zugferd-invoice.xml', 'xrechnung.xml'];

export interface PdfExtraction {
  xml: string;
  attachmentName: string;
  allAttachments: string[];
}

export async function extractXmlFromPdf(bytes: Uint8Array): Promise<PdfExtraction> {
  const pdfjs = await import('pdfjs-dist');
  pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl();

  const doc = await pdfjs.getDocument({ data: bytes }).promise;
  const attachments = (await doc.getAttachments()) as Record<
    string,
    { filename?: string; content: Uint8Array }
  > | null;
  const names = Object.keys(attachments ?? {});

  let chosen = names.find((n) => KNOWN_ATTACHMENTS.includes(n.toLowerCase()));
  if (!chosen) chosen = names.find((n) => n.toLowerCase().endsWith('.xml'));
  if (!chosen || !attachments) {
    throw new Error('Keine eingebettete XML-Rechnung in dieser PDF gefunden.');
  }

  return {
    xml: new TextDecoder('utf-8').decode(attachments[chosen].content),
    attachmentName: chosen,
    allAttachments: names,
  };
}
